export default __webpack_public_path__ + "static/media/gym-disabled.869e976f.png";